"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForAppRegister = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var GetPhoneDynamicCodeForAppRegister = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetPhoneDynamicCodeForAppRegister, _super);
    function GetPhoneDynamicCodeForAppRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取注册手机验证码';
        _this.code = '101072';
        _this.desc = '获取注册手机验证码';
        _this.requestParams = new dynamicCode_1.GetPhoneDynamicCodeForAppRegisterRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetPhoneDynamicCodeForAppRegister;
}(service_1.BaseService));
exports.GetPhoneDynamicCodeForAppRegister = GetPhoneDynamicCodeForAppRegister;
//# sourceMappingURL=getPhoneDynamicCodeForAppRegister.js.map